import * as termActions from './actions';

import termReducer from './reducers';
import * as termSelectors from './selectors';

export { termActions, termSelectors };
export default termReducer;
